import { ComponentsOverrides, ComponentsProps, ComponentsVariants, Theme } from '@mui/material/styles';

export const classes: {
    defaultProps?: ComponentsProps['MuiTableRow'];
    styleOverrides?: ComponentsOverrides<Theme>['MuiTableRow'];
    variants?: ComponentsVariants['MuiTableRow'];
} = {
    styleOverrides: {
        root: {
            '&$selected, &$selected:hover': {
                backgroundColor: 'transparent',
            },
        },
    },
};
